import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import './css/index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    // TODO: 04/26/23  turn strict mode back on

    <React.StrictMode>
        <BrowserRouter basename="/calc">
            <App />
        </BrowserRouter>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
// TODO    good font with NBC newsPublicoText,Georgia,Publico Text,Times New Roman,Times,Baskerville;
